import React, { memo, useMemo, useCallback, useEffect } from 'react';

import { __WEB__ } from '../../../constants/styles';
import { useDispatch, useSelector } from 'react-redux';
import { submitPHARequest, resetStatus } from '../scheduler/slice';
import { saveFormData } from './slice';

import {
  ACTIVE_DUTY,
  BENEFICIARY,
  CIVILIAN_STAFF,
  RETIREE,
  RESERVE_DUTY,
} from '../../../constants/patientRoles';
import SERVICE_BRANCHES from '../../../constants/serviceBranches';

import AppointmentRequestForm from '../scheduler/appointment_request_form';

function normalizeUserData(userData) {
  if (!userData) return null;
  const status =
    userData.employeeType === 'A'
      ? ACTIVE_DUTY
      : userData.employeeType === 'V'
        ? RESERVE_DUTY
        : userData.employeeType === 'Q'
          ? RETIREE
          : userData.employeeType === 'R'
            ? RETIREE
            : userData.userType === 'CIV'
              ? CIVILIAN_STAFF
              : null;

  const serviceBranch =
    {
      USAF: SERVICE_BRANCHES.AIR_FORCE,
      USA: SERVICE_BRANCHES.ARMY,
      USCG: SERVICE_BRANCHES.COAST_GUARD,
      USMC: SERVICE_BRANCHES.MARINE_CORPS,
      USN: SERVICE_BRANCHES.NAVY,
      USSF: SERVICE_BRANCHES.SPACE_FORCE,
    }[userData.serviceBranch] || null;

  // const email = userData.email;
  const email = userData.email?.endsWith('.ai') ? null : userData.email;

  return {
    firstName: userData.firstName || null,
    lastName: userData.lastName || null,
    email: email || null,
    status: status || null,
    dodId: userData.dodId || null,
    serviceBranch: serviceBranch || null,
    rank: userData.rank || null,
  };
}

const AppointmentRequestFormScreenPublic = memo((props) => {
  const dispatch = useDispatch();
  const formInfo = useSelector((state) => state.screens.baseUnauthed.baseInfoData);
  const baseName = formInfo?.name || '';
  const groups = formInfo?.groups;
  const departments = formInfo?.departments;
  const eventTypeDefaults = formInfo?.eventTypeDefaults;
  const status = useSelector((state) => state.screens.scheduler.aptsRequestStatus);
  const aptsRequestError = useSelector((state) => state.screens.scheduler.aptsRequestError);
  const schedules = useSelector((state) => state.screens.scheduler.scheduleData);
  const savedFormData = useSelector((state) => state.screens.baseUnauthed.savedFormData);
  const dataFromOkta = useMemo(() => {
    return normalizeUserData(props.userData);
  }, []);

  useEffect(() => {
    dispatch(resetStatus());
    return function () {
      dispatch(resetStatus());
    };
  }, []);
  const submit = useCallback((requestObj) => {
    dispatch(submitPHARequest({ requestObj }));
  }, []);

  const selectedTimes = useMemo(() => [props.selectedTime], [props.selectedTime]);

  const handleDataChange = useCallback((data) => {
    dispatch(saveFormData(data));
  }, []);

  const prefilledData = useMemo(() => {
    return {
      ...savedFormData,
      ...dataFromOkta,
    };
  }, [dataFromOkta]);

  const readOnlyDataFromOkta = useMemo(() => {
    const readOnlyData = { ...dataFromOkta };
    // any manipulations?
    // delete readOnlyData.email; // don't show email in read-only form
    // delete readOnlyData.rank;
    return readOnlyData;
  }, [dataFromOkta]);

  return (
    <AppointmentRequestForm
      base={props.base}
      selectedDate={props.selectedDate}
      selectedTimes={selectedTimes}
      eventType={props.eventType}
      allDay={props.allDay}
      groups={groups}
      departments={departments}
      status={status}
      errorMessage={aptsRequestError}
      readOnly={false}
      hideButtons={false}
      onSubmit={submit}
      eventTypeDefaults={eventTypeDefaults}
      schedules={schedules}
      admin={props.admin}
      onDataChange={handleDataChange}
      formData={prefilledData}
      readOnlyData={readOnlyDataFromOkta}
    />
  );
});

export default AppointmentRequestFormScreenPublic;
